import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { PurchasableStateMeta } from "./PurchasableStateMeta";

export const DonationMemberMetaFields = {
  description: propertyMeta("description", false, false, false, MetaTypesBase.string),
  restriction: propertyMeta("restriction", false, false, false, MetaTypesBase.string),
  inMemoryOf: propertyMeta("inMemoryOf", false, false, false, MetaTypesBase.string),
  isMatch: propertyMeta("isMatch", false, false, false, MetaTypesBase.boolean),
  inKind: propertyMeta("inKind", false, false, false, MetaTypesBase.boolean),
  skipAck: propertyMeta("skipAck", false, false, false, MetaTypesBase.boolean),
  price: propertyMeta("price", false, false, false, MetaTypesBase.currency),
  donationId: propertyMeta("donationId", false, true, false, MetaTypesBase.number),
  donationDate: propertyMeta("donationDate", false, false, false, MetaTypesBase.Date),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  purchasableState: propertyMeta("purchasableState", false, true, false, PurchasableStateMeta),
  orderId: propertyMeta("orderId", false, false, false, MetaTypesBase.number),
  recurringDonationId: propertyMeta("recurringDonationId", false, false, false, MetaTypesBase.number),
  fundName: propertyMeta("fundName", false, false, false, MetaTypesBase.string),
  initiativeName: propertyMeta("initiativeName", false, false, false, MetaTypesBase.string),
  personName: propertyMeta("personName", false, false, false, MetaTypesBase.string),
  primaryAddress: propertyMeta("primaryAddress", false, false, false, MetaTypesBase.string),
  primaryPhoneNumber: propertyMeta("primaryPhoneNumber", false, false, false, MetaTypesBase.string),
};

export const DonationMemberMeta = typeMeta("DonationMember", DonationMemberMetaFields);
